import { Box } from '@mui/material'
import React from 'react'

export default function Error404() {
    return (
        <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: {md: '1024px', xs: '100%'}, marginTop: '50px', marginX: 'auto'}}>
            <Box component={'img'} alt='404error' loading="lazy" src='https://fundway.com/images/2024/404error.svg' sx={{width: '100%', objectFit: 'cover'}} />
        </Box>
    )
}